import { FC } from "react";

import { DeletionConfirmationModalProps } from "./types";






const DeletionConfirmationModal: FC<DeletionConfirmationModalProps> = ({ isModalVisible, removeCurrentData, restoringCaseData }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '700px'}}>
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title fs-5" id="exampleModalLabel">Warning</h2>
          </div>

          <div className="modal-body">
            <p className="m-0">
              Are you sure you want to delete this prescription request?
            </p>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={restoringCaseData}>Yes</button>
            <button type="button" className="btn btn-danger" onClick={removeCurrentData}>No</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeletionConfirmationModal;
